import React from 'react';

import {
  STATUS_ACTIVE,
  STATUS_INACTIVE,
  STATUS_ERROR,
  STATUS_PENDING_FOR_START,
  STATUS_PENDING_FOR_APPROVAL,
} from 'scenes/SmartRules/constants';

import { ActiveLastRunResults } from './ActiveLastRunResults';
import ErrorOccured from './ErrorOccured';
import { PendingForApprovalLastRunResults } from './PendingForApprovalLastRunResults';
import { PendingForStartLastRunResults } from './PendingForStartLastRunResults';

const lastRunResultByStatus = {
  [STATUS_ACTIVE]: ActiveLastRunResults,
  [STATUS_INACTIVE]: ActiveLastRunResults,
  [STATUS_ERROR]: '—',
  [STATUS_PENDING_FOR_START]: PendingForStartLastRunResults,
  [STATUS_PENDING_FOR_APPROVAL]: PendingForApprovalLastRunResults,
};

const LastRunResults = ({ openChildComponent, row }) => {
  if (row.isFailed) {
    return <ErrorOccured id={row.id} />;
  }

  return React.createElement(lastRunResultByStatus[row.status], {
    row,
    openChildComponent,
  });
};

export default LastRunResults;
